"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VIDEOS = exports.VIDEO = void 0;
const client_1 = require("@apollo/client");
const fragments_1 = require("../../fragments");
exports.VIDEO = (0, client_1.gql) `
  ${fragments_1.PICTURE_FIELDS}
  ${fragments_1.CHAPTER_FIELDS}
  query Video($id: Int!) {
    restricted {
      video(id: $id) {
        id
        title
        museId
        viewsToday
        views
        userViewed
        thumbnail
        concepts {
          id
          name
          status
          userNote {
            id
            userId
            conceptId
            note
            updatedAt
          }
          userChapter {
            id
            userId
            conceptId
            explanation
            updatedAt
          }
          topic {
            id
            name
            typeId
          }
          chapter {
            ...ChapterFields
          }
        }
        osceStation {
          id
          name
          hiddenName
          status
          userNote {
            id
            userId
            stationId
            note
            updatedAt
          }
          osceType {
            id
          }
          entitlement {
            id
            name
            index
          }
          candidateBrief
          examinerBrief
          actorBrief
          explanation
          marks {
            id
            index
            osceStationId
            header
            name
            choices {
              id
              name
              type
              score
            }
          }
          candidatePictures {
            ...PictureFields
          }
          actorPictures {
            ...PictureFields
          }
          examinerPictures {
            ...PictureFields
          }
          walkthroughPictures {
            ...PictureFields
          }
          lastOsceMarksheetId
        }
        live
        description
        duration
        startTime
        status
        endTime
        files {
          id
          title
          url
          videoId
        }
      }
    }
  }
`;
exports.VIDEOS = (0, client_1.gql) `
  query Videos($platform: Int!, $filter: Int!, $search: String, $limit: Int!) {
    restricted {
      videos(
        platform: $platform
        filter: $filter
        search: $search
        limit: $limit
      ) {
        id
        title
        museId
        thumbnail
        viewsToday
        views
        live
        description
        duration
        startTime
        endTime
        osceStation {
          id
          name
          osceType {
            id
          }
        }
        concepts {
          id
          name
          topicId
          topic {
            id
            name
            typeId
          }
        }
      }
    }
  }
`;
